import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lc_tree_node_expand",
  "use": "lc_tree_node_expand-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"lc_tree_node_expand\"><defs><style type=\"text/css\"></style></defs><path d=\"M271.53514739 1007.35040928l499.89751814-499.8975181-498.38273575-498.38273573z\" p-id=\"2152\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol